module.exports = __webpack_public_path__ + "static/media/brain.5054ef45.png";